/* eslint-disable @typescript-eslint/no-explicit-any */
export const GTMHeadScript = (trackingId?: string) => {
  return trackingId
    ? `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${trackingId}');`
    : '';
};

export const GTMBodyTag = (trackingId?: string) => {
  return trackingId ? (
    <noscript>
      <iframe
        height="0"
        src={`https://www.googletagmanager.com/ns.html?id=${trackingId}`}
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
        width="0"
      />
    </noscript>
  ) : null;
};

// FORMATTERS -----------------------------------------------------------------

export const trackEvent = (data: Tracking.Value) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer ?? ([] as unknown as Window['dataLayer']);
  window.dataLayer?.push(data);
};

// EVENTS ---------------------------------------------------------------------

/**
 * Tracks user data after login.
 */
export const trackUserDataEvent = (data: {
  user_data: Pick<
    Tracking.Properties.UserData,
    'email' | 'first_name' | 'last_name'
  >;
}) => {
  trackEvent({
    user_data: data.user_data,
  });
};

/**
 * Tracks when a address is added.
 */
export const trackAddressAddedEvent = (data: {
  user_data: Tracking.Properties.UserData;
}) => {
  trackEvent({
    event: 'address_added',
    user_data: data.user_data,
  });
};

/**
 * Tracks when a user clicks on a booking button.
 */
export const trackClickBookingEvent = (data: {
  items: any;
  travel_details: any;
}) => {
  trackEvent({
    event: 'add_to_cart',
    items: data.items,
    travel_details: data.travel_details,
  });
};

/**
 * Tracks when a email is added.
 */
export const trackEmailAddedEvent = (data: {
  user_data: Pick<Tracking.Properties.UserData, 'email'>;
}) => {
  trackEvent({
    event: 'email_added',
    user_data: data.user_data,
  });
};

/**
 * Tracks when a user loads a page.
 */
export const trackPageLoadEvent = (data: {
  content_group: Tracking.Properties.ContentGroup;
}) => {
  trackEvent({
    content_group: data.content_group,
  });
};

/**
 * Tracks when a user submits a search.
 */
export const trackSubmitSearchEvent = (data: {
  search_details: Tracking.Properties.SearchDetails;
}) => {
  trackEvent({
    event: 'search',
    search_details: data.search_details,
  });
};

/**
 * Tracks when a user views a page.
 */
export const trackViewEvent = (
  data: Content.Components['GtmDataLayerObject'],
) => {
  if (!data) return;

  trackEvent(data as Tracking.Value);
};

/**
 * Tracks when a user views a "area" page.
 */
export const trackViewAreaEvent = (data: {
  travel_details: Pick<
    Tracking.Properties.TravelDetails,
    'area' | 'country' | 'destination' | 'region'
  >;
}) => {
  trackEvent({
    event: 'view_area',
    travel_details: data.travel_details,
  });
};

/**
 * Tracks when a user views a "country" page.
 */
export const trackViewCountryEvent = (data: {
  travel_details: Pick<Tracking.Properties.TravelDetails, 'country'>;
}) => {
  trackEvent({
    event: 'view_country',
    travel_details: data.travel_details,
  });
};

/**
 * Tracks when a user views a "destination" page.
 */
export const trackViewDestinationEvent = (data: {
  travel_details: Pick<
    Tracking.Properties.TravelDetails,
    'country' | 'destination' | 'region'
  >;
}) => {
  trackEvent({
    event: 'view_destination',
    travel_details: data.travel_details,
  });
};

/**
 * Tracks when a user views a "hotel" page.
 */
export const trackViewHotelEvent = (data: {
  items: Omit<Tracking.Properties.Item, 'price' | 'quantity'>[];
  travel_details: Tracking.Properties.TravelDetails;
}) => {
  trackEvent({
    event: 'view_item',
    items: data.items,
    travel_details: data.travel_details,
  });
};

/**
 * Tracks when a user views a "region" page.
 */
export const trackViewRegionEvent = (data: {
  travel_details: Pick<Tracking.Properties.TravelDetails, 'country' | 'region'>;
}) => {
  trackEvent({
    event: 'view_region',
    travel_details: data.travel_details,
  });
};
